import { MemberStatus } from '@modules/projects/project-members.enum'
import type { WorkspaceMember } from '@modules/projects/project-members.interface'
import { normalizeInviteEmail } from '@modules/projects/project-members.utils'

import { InviteEmailConflict } from './invite-email-conflict.enum'

export const findInviteEmailConflict = (members: WorkspaceMember[], email: string): InviteEmailConflict | null => {
  const normalizedEmail = normalizeInviteEmail(email)
  if (!normalizedEmail) {
    return null
  }

  const existingMember = members.find((member) => normalizeInviteEmail(member.email) === normalizedEmail)
  if (!existingMember) {
    return null
  }

  if (existingMember.status === MemberStatus.PENDING) {
    return InviteEmailConflict.ALREADY_INVITED
  }

  return InviteEmailConflict.ALREADY_MEMBER
}
